import { getDateWithSpecificFormat } from '../../../../data-transform';


export default function myOrdersTableColumns(config){
    //console.log(config);
    let result = {};
    let tableData = [];

    config.data.forEach(order => {
        let row = [];
        const rowId = order.orderId;
        config.columns.forEach(column => {
           // console.log(column);
            let columnValue = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "collectionNumber") {
                    columnValue = order.orderId || "";
                    displayAsIs = true;
                }
                if (column.id === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.createdDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "status") {
                    columnValue = order.status || "";
                    displayAsIs = true;
                }
                if (column.id === "quantityOfAssets") {
                    columnValue = order.categoryList.quantity || "";
                    displayAsIs = true;
                }
                if (column.id === "netValue") {
                    columnValue = order.totalCost || "";
                    displayAsIs = true;
                }
                if (column.id === "reportingStatus") {
                    columnValue = order.company || "";
                    displayAsIs = true;
                }
                if (column.id === "paymentStatus") {
                    columnValue = order.userType || "";
                    displayAsIs = true;
                }
            }
            row.push({
                [column.id] : {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });
        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}